import {
  FormStatusEnum,
  FormStatusEnumToText,
} from "app/services/api/types/forms/enums/FormStatusEnums";
import { Text, View } from "react-native";

interface Props {
  status: FormStatusEnum;
}

const StatusToContainerClassName = {
  [FormStatusEnum.SUBMITTED]: "bg-green-500",
  [FormStatusEnum.DRAFT]: "bg-gray-500",
  [FormStatusEnum.PENDING_SIGNOFF]: "bg-yellow-500",
  [FormStatusEnum.VOIDED]: "bg-red-500",
};

const StatusToTextClassName = {
  [FormStatusEnum.SUBMITTED]: "text-white",
  [FormStatusEnum.DRAFT]: "text-white",
  [FormStatusEnum.PENDING_SIGNOFF]: "text-white",
  [FormStatusEnum.VOIDED]: "text-white",
};

export function AssessmentStatus({ status }: Props) {
  if (status === FormStatusEnum.SUBMITTED) return null;

  return (
    <View
      className={`items-center py-1 px-2 rounded-full ${StatusToContainerClassName[status]}`}
    >
      <Text
        className={`text-xs font-semibold ${StatusToTextClassName[status]}`}
      >
        {FormStatusEnumToText[status]}
      </Text>
    </View>
  );
}
